@if (suggestion().bundleType === 'open') {
  <ui-configurable-bundle-suggestion-card
    [suggestion]="suggestion()"
    (clicked)="clicked.emit()"
  ></ui-configurable-bundle-suggestion-card>
} @else {
  @let endUserPrice = suggestion().prices?.endUser;
  @let showEndUserPrice = productHasPrice() && endUserPrice;

  <a mat-list-item
     [lines]="showEndUserPrice ? 3 : 2"
     (click)="clicked.emit()"
     uiLink
     [link]="'/product/' + suggestion().sku"
  >

  @if (suggestion().images?.[0]; as image) {
    <img
      [alt]="image.large"
      [src]="image.small"
      height="56"
      width="56"
      matListItemIcon
    >
  }

  <span matListItemTitle>{{ suggestion().name }}</span>
  <span matListItemLine>{{ suggestion().packagingUnit }}</span>
  @if (showEndUserPrice) {
    <span matListItemLine>{{ suggestion().prices?.endUserPriceLabel }}: <ui-product-prices-formatter [showThousandthsPlace]="false" [price]="endUserPrice"></ui-product-prices-formatter></span>
  }

  <div
    matListItemMeta
    class="add-to-cart-price-wrapper"
    (click)="$event.stopPropagation();$event.preventDefault()">

    @if (productHasPrice() && suggestion().prices?.singleUnit; as singleUnit) {
      <ui-product-prices-formatter [price]="singleUnit"></ui-product-prices-formatter>
    }
    <ui-add-to-cart-small uiProductTrackingList="schnellsuchfunktion" [position]="position()" [product]="suggestion()" [sku]="suggestion().sku"></ui-add-to-cart-small>
  </div>
  </a>
}
